import * as React from 'react';
import spreadsheetsApiClient from '../lib/spreadsheetsApiClient';
import { EntityContext } from './EntityProvider';
const WorkbookLoader = _ref => {
  let {
    children,
    environment,
    exercise
  } = _ref;
  const entityContext = React.useContext(EntityContext);
  const [workbookReady, setWorkbookReady] = React.useState(false);
  const workbook = React.useMemo(() => {
    return exercise === undefined ? undefined : entityContext.getUserWorkbook(exercise.workbookId);
  }, [exercise, entityContext]);
  const exerciseId = exercise === null || exercise === void 0 ? void 0 : exercise.id;
  const exerciseWorkbookId = exercise === null || exercise === void 0 ? void 0 : exercise.workbookId;
  const isWorkbookDefined = workbook != null;

  // Load workbook when exercise or workbook changes
  React.useEffect(() => {
    if (!isWorkbookDefined && exerciseWorkbookId != null) {
      spreadsheetsApiClient(environment).getWorkbook(exerciseWorkbookId).then(definedWorkbook => {
        entityContext.setUserWorkbook(definedWorkbook.workbookId, definedWorkbook);
      });
    }
  }, [entityContext, environment, exerciseWorkbookId, isWorkbookDefined]);
  const resetWorkbook = React.useCallback(() => {
    if (exercise === undefined) {
      return;
    }
    const {
      workbookId
    } = exercise;
    setWorkbookReady(false);
    spreadsheetsApiClient(environment).resetWorkbook(workbookId).then(() => {
      entityContext.deleteUserWorkbook(workbookId);
    });
  }, [entityContext, environment, exercise]);

  // Set sample data when workbook exists
  React.useEffect(() => {
    if (isWorkbookDefined && exerciseId != null) {
      setWorkbookReady(false);
      spreadsheetsApiClient(environment).setSampleData(exerciseId).then(() => {
        setWorkbookReady(true);
      }).catch(() => {
        /**
         * Prevents the application from staying in a perpetual loading state since otherwise workbookReady
         * would never become true upon transient failures (e.g., 504 Gateway Timeout).
         */
        resetWorkbook();
      });
    }
  }, [environment, exerciseId, isWorkbookDefined, resetWorkbook]);
  return React.useMemo(() => children({
    resetWorkbook,
    workbook,
    workbookReady
  }), [children, workbook, resetWorkbook, workbookReady]);
};
export default WorkbookLoader;